import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@creditas-ui/react';
import { ContainerOptions, TermButton } from './SelectTerm.styles';
export var SelectTerm = props => {
  var {
    options,
    onChangeOption,
    text,
    error
  } = props;
  var [currentPosition, setPosition] = useState(-1);

  var handleClickOption = (option, position) => {
    if (onChangeOption) onChangeOption(option);
    setPosition(position);
  };

  var renderOptions = options.map((option, index) => {
    var isSelected = currentPosition === index;
    var textSplitted = option.text.split(' ');
    var title = /*#__PURE__*/React.createElement(Typography, {
      variant: "bodyMdBold"
    }, textSplitted[0]);
    var subtitle = textSplitted[1] ? /*#__PURE__*/React.createElement(Typography, {
      variant: "bodySmRegular"
    }, textSplitted[1]) : null;
    return /*#__PURE__*/React.createElement(TermButton, {
      id: option.text,
      key: option.text,
      "data-testid": option.text,
      isSelected: isSelected,
      onClick: () => handleClickOption(option, index),
      className: isSelected ? 'term-button-selected' : ''
    }, title, subtitle);
  });
  useEffect(() => {
    var lastPosition = options.length - 1;
    var lastOption = options[lastPosition];
    handleClickOption(lastOption, lastPosition);
  }, []);
  return /*#__PURE__*/React.createElement(Box, {
    "data-testid": props['data-testid']
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodyMdBold",
    marginBottom: "8px"
  }, text), /*#__PURE__*/React.createElement(ContainerOptions, null, renderOptions), error ? /*#__PURE__*/React.createElement(Typography, {
    variant: "bodyXsRegular",
    color: "error.60",
    marginTop: "8px"
  }, error) : null);
};
//# sourceMappingURL=SelectTerm.component.js.map